/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// @material-ui/icons
import Person from "@material-ui/icons/Person";
//custom components TCDG
import ListCursos from "views/Cursos/ListCursos.js";
import FormCursos from "views/Cursos/FormCursos.js";
import FormSongs from "views/Cursos/FormSongs.js"
import CourseNavs from "components/CoursesNav/CourseNav.js"

import ListCategories from "views/Categories/List.js";
import ListSongCategories from "views/SongCategories/List.js";

import ListStudents from "views/Students/ListStudents.js"
// core components/views for RTL layout
// import RTLPage from "views/RTLPage/RTLPage.js";
import FormStudents from "views/Students/FormStudents";
import ListTrash from "views/Trash/ListTrash.js";
import Countries from "views/Countries/Countries.js";
import Precios from "views/Precios/Precios.js";
import Mailing from "views/Mailing/Mailing.js";
import MailHistory from "views/Mailing/MailHistory.js";
import MailingExport from "views/Mailing/MailingExport.js";
import Outbox from "views/Messaging/Outbox.js";
import MessagingDashboard from "views/Dashboard/MessagingDashboard.js";
import MailSequenceDashboard from "views/Dashboard/MailSequenceDashboard.js";
import Insights from "views/Insights/Insights.js";
import MetaAds from "views/MetaAds/MetaAds.js";
import AdsControl from "views/AdsControl/AdsControl.js";
import Scripts from "views/Scripts/Scripts.js";
import Banner from "views/Banner/FormBanners.js";
import ListBanners from "views/Banner/ListBanners.js";
import ListSuscriptions from "views/Suscriptions/ListSuscriptions.js";
import ListPagos from "views/Pagos/ListPagos.js";
import Activation from "views/Activation/Activation.js";
import DashboardView from "views/DashboardView/DashboardView.js";
import ChangePassword from "views/ChangePassword/ChangePassword.js";
import DashboardAdSpend from "./views/Dashboard/DashboardAdSpend.js";
import WhatsAppInbox from "views/WhatsApp/WhatsAppInbox.js";
import WhatsAppChat from "views/WhatsApp/WhatsAppChat.js";
import WhatsAppAutoReplies from "views/WhatsApp/WhatsAppAutoReplies.js";
import Inbox from "views/Inbox/Inbox.js";
import Realtime from "views/Realtime/Realtime.js";


const dashboardRoutes = [
  // --- Más usados (nivel 1) ---
  {
    path: "/tiempo-real",
    buttonPath: "/tiempo-real",
    name: "Tiempo real",
    icon: "public",
    displayName: "Tiempo real",
    component: Realtime,
    layout: "/admin",
    profiles: null,
  },
  {
    path: "/dashboard-ad-spend",
    buttonPath: "/dashboard-ad-spend",
    name: "Dashboard Ads",
    icon: "bar_chart",
    displayName: "Dashboard Ads",
    component: DashboardAdSpend,
    layout: "/admin",
    profiles: null,
  },
  {
    path: "/insights",
    buttonPath: "/insights",
    name: "Insights",
    icon: "insights",
    displayName: "Insights",
    component: Insights,
    layout: "/admin",
    profiles: null,
  },
  {
    path: "/control-anuncios",
    buttonPath: "/control-anuncios",
    name: "Control de anuncios",
    icon: "track_changes",
    displayName: "Control de anuncios",
    component: AdsControl,
    layout: "/admin",
    profiles: null,
  },
  {
    path: "/meta-ads",
    buttonPath: "/meta-ads",
    name: "Meta Ads",
    icon: "campaign",
    displayName: "Meta Ads",
    component: MetaAds,
    layout: "/admin",
    profiles: null,
  },
  {
    path: "/Students",
    buttonPath: "/Students",
    name: "Alumnos",
    icon: "people",
    displayName: "Alumnos",
    component: ListStudents,
    layout: "/admin",
    profiles: null,
  },
  {
    path: "/Student-new/:studentId?",
    name: "Crear Alumno",
    icon: "person_add",
    displayName: "Crear Alumno",
    component: FormStudents,
    layout: "/admin",
    subRoute: true,
    profiles: null,
  },
  {
    path: "/changePassword",
    buttonPath: "/changePassword",
    name: "Cambio de Contraseña",
    icon: "vpn_key",
    displayName: "Cambio de Contraseña",
    component: ChangePassword,
    layout: "/admin",
    profiles: 'customerService',
  },
  {
    path: "/sales",
    buttonPath: "/sales",
    name: "Ventas",
    icon: "attach_money",
    displayName: "Ventas",
    component: ListSuscriptions,
    layout: "/admin",
    profiles: null,
  },

  // --- Pagos (buscador de pagos entrantes) ---
  {
    path: "/payments",
    buttonPath: "/payments",
    name: "Pagos",
    icon: "credit_card",
    displayName: "Pagos",
    component: ListPagos,
    layout: "/admin",
    profiles: null,
  },

  // --- Centro de Mensajes (Inbox unificado) ---
  // Abre en pestaña nueva, sin layout admin (pantalla completa)
  {
    path: "/inbox",
    buttonPath: "/inbox",
    name: "Centro de Mensajes",
    icon: "all_inbox",
    displayName: "Centro de Mensajes",
    component: Inbox,
    layout: "",
    external: true,
    openInNewTab: true,
    profiles: null,
  },

  // --- Autorespuestas (WhatsApp + DMs de Meta) ---
  // Ítem suelto, sin grupo. La bandeja de WhatsApp quedó cubierta por el Centro de
  // Mensajes, así que ella y el chat salen del menú pero SIGUEN registradas como
  // subRoute: si se borraran las rutas, los links a /whatsapp-chat/:id romperían.
  {
    path: "/whatsapp-auto-replies",
    buttonPath: "/whatsapp-auto-replies",
    name: "Autorespuestas",
    icon: "smart_toy",
    displayName: "Autorespuestas",
    component: WhatsAppAutoReplies,
    layout: "/admin",
    profiles: null,
  },
  {
    path: "/whatsapp",
    name: "Bandeja WhatsApp",
    icon: "inbox",
    displayName: "Bandeja WhatsApp",
    component: WhatsAppInbox,
    layout: "/admin",
    subRoute: true,
    profiles: null,
  },
  {
    path: "/whatsapp-chat/:conversationId",
    name: "WhatsApp Chat",
    icon: "chat",
    displayName: "Chat WhatsApp",
    component: WhatsAppChat,
    layout: "/admin",
    subRoute: true,
    profiles: null,
  },

  // --- Grupo: Contenido ---
  {
    group: true,
    name: "Contenido",
    icon: "school",
    layout: "/admin",
    profiles: null,
    children: [
      {
        path: "/cursos/:type?",
        buttonPath: "/cursos/Cursos",
        name: "Cursos",
        icon: Person,
        displayName: "Cursos",
        component: ListCursos,
        layout: "/admin",
        profiles: null,
      },
      {
        path: "/curso-nuevo/:courseId?",
        name: "nuevo-curso",
        icon: Person,
        displayName: "Agregar nuevo curso.",
        component: FormCursos,
        layout: "/admin",
        subRoute: true,
        profiles: null,
      },
      {
        path: "/song/:songId?",
        name: "song",
        icon: Person,
        displayName: "Agregar nueva canción.",
        component: FormSongs,
        nav: CourseNavs,
        layout: "/admin",
        subRoute: true,
        profiles: null,
      },
      {
        path: "/categories",
        buttonPath: "/categories",
        name: "Categorías",
        icon: "category",
        displayName: "Categorías",
        component: ListCategories,
        layout: "/admin",
        profiles: null,
      },
      {
        path: "/cursos/:type?",
        buttonPath: "/cursos/Canciones",
        name: "Canciones",
        icon: "music_note",
        displayName: "Canciones",
        component: ListCursos,
        layout: "/admin",
        profiles: null,
      },
      {
        path: "/songCategories",
        buttonPath: "/songCategories",
        name: "Cat. Canciones",
        icon: "category",
        displayName: "Cat. Canciones",
        component: ListSongCategories,
        layout: "/admin",
        profiles: null,
      },
    ],
  },

  // --- Grupo: Marketing ---
  {
    group: true,
    name: "Marketing",
    icon: "campaign",
    layout: "/admin",
    profiles: null,
    children: [
      {
        path: "/mailing/",
        buttonPath: "/mailing",
        name: "Mailing",
        icon: "email",
        displayName: "Mailing",
        component: Mailing,
        layout: "/admin",
        subRoute: false,
        profiles: null,
      },
      {
        // Va DESPUÉS de /mailing/ a propósito: el Navbar matchea por substring,
        // así el name "Listas para mailing" sobrescribe a "Mailing" al estar acá.
        path: "/mailing-export",
        buttonPath: "/mailing-export",
        name: "Listas Mailing",
        icon: "group",
        displayName: "Listas para mailing",
        nav: () => (
          <span style={{
            fontSize: 13, color: "#94A3B8", fontWeight: 400,
            marginLeft: 16, alignSelf: "center",
          }}>
            Segmentá la base y exportá para tu próxima campaña
          </span>
        ),
        component: MailingExport,
        layout: "/admin",
        profiles: null,
      },
      {
        path: "/history",
        buttonPath: "/history",
        name: "Historial Mails",
        icon: "history",
        displayName: "Historial Mails",
        component: MailHistory,
        layout: "/admin",
        subRoute: true,
        profiles: null,
      },
      {
        path: "/outbox",
        buttonPath: "/outbox",
        name: "Envíos",
        icon: "send",
        displayName: "Envíos (Outbox)",
        nav: () => (
          <span style={{
            fontSize: 13, color: "#94A3B8", fontWeight: 400,
            marginLeft: 16, alignSelf: "center",
          }}>
            Qué se está mandando: estado, reintentos y preview (email + WhatsApp)
          </span>
        ),
        component: Outbox,
        layout: "/admin",
        subRoute: true,
        profiles: null,
      },
      {
        path: "/messaging-dashboard",
        buttonPath: "/messaging-dashboard",
        name: "Dashboard Mensajería",
        icon: "insights",
        displayName: "Dashboard Mensajería",
        nav: () => (
          <span style={{
            fontSize: 13, color: "#94A3B8", fontWeight: 400,
            marginLeft: 16, alignSelf: "center",
          }}>
            Cola, recupero de carritos, seguimiento automático y envíos por día
          </span>
        ),
        component: MessagingDashboard,
        layout: "/admin",
        subRoute: true,
        profiles: null,
      },
      {
        path: "/mail-sequence",
        buttonPath: "/mail-sequence",
        name: "Secuencia de mails",
        // Icono de la primera tanda de Material Icons a propósito: los nuevos tipo
        // `forward_to_inbox` o `mark_email_read` no están en fuentes viejas y se ven como el
        // nombre literal escrito al lado del texto.
        icon: "email",
        displayName: "Secuencia de mails",
        nav: () => (
          <span style={{
            fontSize: 13, color: "#94A3B8", fontWeight: 400,
            marginLeft: 16, alignSelf: "center",
          }}>
            Envíos, aperturas, clics, quiénes llegaron al pago y compraron — por secuencia
          </span>
        ),
        component: MailSequenceDashboard,
        layout: "/admin",
        // subRoute: false para que SE VEA en el menú. El Sidebar hace `if (prop.subRoute)
        // return null`, así que un true la deja accesible sólo por URL — que es lo que le
        // pasa a "Dashboard Mensajería".
        subRoute: false,
        profiles: null,
      },
      {
        path: "/promotions",
        buttonPath: "/promotions",
        name: "Promociones",
        icon: "local_offer",
        displayName: "Promociones",
        component: ListBanners,
        layout: "/admin",
        profiles: null,
      },
      {
        path: "/promotion/:bannerId?",
        name: "Promociones",
        icon: "local_offer",
        displayName: "Promociones",
        component: Banner,
        layout: "/admin",
        subRoute: true,
        profiles: null,
      },
    ],
  },

  // --- Grupo: Configuración ---
  {
    group: true,
    name: "Configuración",
    icon: "settings",
    layout: "/admin",
    profiles: null,
    children: [
      {
        // Pantalla nueva: los 32 países en una tabla, con el precio en dólares y el histórico.
        // Es de sólo lectura; editar sigue estando en «Editar país».
        path: "/precios",
        buttonPath: "/precios",
        name: "Precios",
        icon: "monetization_on",
        displayName: "Precios",
        component: Precios,
        layout: "/admin",
        subRoute: false,
        profiles: null,
      },
      {
        // El editor de siempre. Se le cambió el nombre, no el comportamiento: es el único
        // camino que escribe precios y el que dispara los triggers de price_history.
        path: "/countries/",
        buttonPath: "/countries",
        name: "Editar país",
        icon: "edit",
        displayName: "Editar país",
        component: Countries,
        layout: "/admin",
        subRoute: false,
        profiles: null,
      },
      {
        path: "/scripts",
        buttonPath: "/scripts",
        name: "Scripts",
        icon: "code",
        displayName: "Scripts",
        component: Scripts,
        layout: "/admin",
        profiles: null,
      },
      {
        path: "/trash",
        buttonPath: "/trash",
        name: "Papelera",
        icon: "delete",
        displayName: "Papelera",
        component: ListTrash,
        layout: "/admin",
        profiles: null,
      },
    ],
  },

];

// Utilidad para aplanar las rutas (usado por el Router en Admin.js)
export function flattenRoutes(routes) {
  return routes.reduce(function (acc, route) {
    if (route.children) {
      return acc.concat(route.children);
    }
    return acc.concat(route);
  }, []);
}

export default dashboardRoutes;
